<template>
    <div class="row">
        <div class="col-md-5">
          <img :src="practitioner.portrait.thumb_url" v-if="practitioner.portrait" style="width: 100%; border-radius: 14px; overflow: hidden;"/>
        </div>
        <div class="col-md-24">
          <b>{{ practitioner.name }}</b><br>
          {{ practitioner.presentation }}
        </div>
         <div class="col-md-5">

         </div>
        <div class="col-md-10">
            <div v-if="practitioner.is_public">
                <img src="/images/check.png" style="width: 22px; margin-right: 4px; transform: translateY(-2px);"> Visas i klippkort
            </div>
        </div>
        <div class="col-md-6">
            <button class="btn btn-primary" style="float:right;" @click="edit">Redigera</button>
        </div>

    </div>
</template>

<script>

export default {

    props: {
        practitioner: {
            required: true
        }
    },

    data () {
        return {

        }
    },

    methods: {
        edit () {
            this.$emit('edit', this.practitioner.id)
        }
    }

}
</script>
